import { useLocation } from "react-router-dom";

export const Activity = () => {
  const location = useLocation();
  const data = location.state?.activity;

  return (
    <section className="antialiased dark:bg-gray-900">
      <div className="mx-auto max-w-screen-lg px-4 2xl:px-0">
        <h2 className="text-xl font-semibold text-blue-700">User Activity Details</h2>

        <div className="grid grid-cols-2 gap-6 py-4">
          <div>
            <h3 className="font-semibold text-gray-700">Request Information</h3>
            <ul className="list-disc ml-6 text-sm">
              <li>
                <strong>Method:</strong> {data.method}
              </li>
              <li>
                <strong>URL:</strong> {data.url}
              </li>
              <li>
                <strong>Name:</strong> {data.name}
              </li>
              <li>
                <strong>Device:</strong> {data.device}
              </li>
              <li>
                <strong>OS:</strong> {data.os}
              </li>
              <li>
                <strong>User Agent:</strong> {data.userAgent}
              </li>
              <li>
                <strong>IP Address:</strong> {data.ipAddress}
              </li>
              <li>
                <strong>Date:</strong>{" "}
                {new Date(data.createdAt).toLocaleString()}
              </li>
            </ul>
          </div>

          <div className="">
            <div>
              <h3 className="font-semibold text-gray-700">User Information</h3>
              <ul className="list-disc ml-6 text-sm">
                <li>
                  <strong>Full Name:</strong> {data.user.firstName}{" "}
                  {data.user.lastName}
                </li>
                <li>
                  <strong>Email:</strong> {data.user.email}
                </li>
                <li>
                  <strong>Phone:</strong> {data.user.phoneNumber}
                </li>
                <li>
                  <strong>Country:</strong> {data.user.country}
                </li>
              </ul>
            </div>

            <div className="py-3">
              <h3 className="font-semibold text-gray-700">Role</h3>
              <ul className="list-disc ml-6 text-sm">
                {data.user.roles.map((role: any) => (
                  <li key={role.id}>
                    <strong>{role.name}</strong> - {role.category}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
